export default __webpack_public_path__ + "static/media/img-0717-estonia-full-face.d94f44a9.png";